import { type UserVoucherResDisplayStatus } from '@/api';

/*
 * available: 이용권 사용 가능 상태
 * plain: 이용권이 아예 없거나 다 만료되어서 사용할 이용권이 없는 상태
 * destructive: 이미 기존 플랜이 있거나 플랜 적용이 예정되어 있어, 이용권을 사용할 수 없는 상태
 */

export type VoucherGuideState = 'available' | 'plain' | 'destructive';

export type VoucherItem = {
  id: string;
  status: UserVoucherResDisplayStatus;
  name: string;
  code: string;
  planDuration: string;
  planType: string;
  expirationDate: string;
  canUseNow: boolean;
  timezone: string;
};

export const VOUCHER_STATUS_LABELS = {
  UNUSED: 'voucher.status.unused',
  IN_USE: 'voucher.status.using',
  USED: 'voucher.status.used',
  EXPIRED: 'voucher.status.expired',
  DEACTIVATED: 'voucher.status.deactivated',
} as const satisfies Record<UserVoucherResDisplayStatus, string>;

export type UseVoucherHandler = (params: {
  id: string;
  name: string;
  planType: string;
}) => void;
